<template>
  <vx-card :title="title" class="vx-card_full-height">
    <div slot="actions" class="flex items-center">
<!--      <div class="flex items-center">-->
<!--        <label class="vs-select&#45;&#45;label mb-1 mr-2 block">Пени начисленные за период</label>-->
<!--        <vs-switch v-model="showInMonthRange" ref="toggleShowInactiveDevices" />-->
<!--      </div>-->
      <slot name="actions" />
    </div>
    <table class="financial-analytics-account-month-summary-table" v-if="showSummary">
      <thead>
      <tr>
        <th>
          Месяц
        </th>
        <th>
          Начислено
        </th>
        <th>
          Оплачено
        </th>
        <th>
          Пени
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <div class="capitalize">{{ summaryData.month | moment('MMMM YYYY') }}</div>
        </td>
        <td>
          <div>{{ summaryData.charge | numberWithSpaces }}</div>
        </td>
        <td>
          <div>{{ summaryData.payment | numberWithSpaces }}</div>
        </td>
        <td>
          <div>{{ summaryData.fine_sum | numberWithSpaces }}</div>
        </td>
      </tr>
      </tbody>
    </table>
    <vs-tabs class="vs-tabs_full-page">
      <vs-tab label="Начисления">
        <vs-table
          ref="table"
          :data="accountChargesInfo"
          class="financial-analytics-tariffs-table"
          no-data-text="Начислений нет"
        >
          <template slot="thead">
            <vs-th>Тариф</vs-th>
            <vs-th>Значение тарифа</vs-th>
            <vs-th>Объем услуг</vs-th>
            <vs-th>Сумма начисления</vs-th>
            <vs-th>Сумма перерасчета</vs-th>
            <vs-th>Сумма льгот</vs-th>
            <vs-th>Итого</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
            <template v-for="(tr, indextr) in data">
              <vs-tr :data="tr" :key="indextr" class="tariff-row financial-analytics-tariffs-table__group-row">
                <vs-td class="financial-analytics-tariffs-table__cell financial-analytics-tariffs-table__group-name">
                  <span class="tariff-row__name">{{ tr.group_name }}</span>
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell" />
                <vs-td class="financial-analytics-tariffs-table__cell" />
                <vs-td class="financial-analytics-tariffs-table__cell" />
                <vs-td class="financial-analytics-tariffs-table__cell" />
                <vs-td class="financial-analytics-tariffs-table__cell" />
                <vs-td class="financial-analytics-tariffs-table__cell" />
              </vs-tr>
              <template v-for="(charge, indexCharge) in tr.charges">
                <vs-tr
                  :data="charge"
                  :key="`tariff-${indextr}-${indexCharge}`"
                  class="tariff-row financial-analytics-tariffs-table__row"
                >
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span class="tariff-row__name">
                      {{ charge.name }}
                      <span v-if="$can('rp.debug', 'read')" class="font-medium">#{{ charge.tarifs_id }}</span>
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span>
                      {{ charge.tarifs_value }}
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span>
                      {{ charge.consumption }}
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span>
                      {{ charge.sum }}
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span>
                      {{ charge.recalculation_sum }}
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span
                      @click="charge.priv_id ? openChargePrivilegePopup(charge.priv_id) : () => {}"
                      :class="{'link-icon': charge.priv_id}"
                    >
                      {{ charge.privilege_sum }}
                    </span>
                  </vs-td>
                  <vs-td class="financial-analytics-tariffs-table__cell">
                    <span>
                      {{
                        Math.round(((Number(charge.privilege_sum) || 0) + (Number(charge.sum) || 0) + (Number(charge.recalculation_sum) || 0)) * 100) / 100
                      }}
                    </span>
                  </vs-td>
                </vs-tr>
              </template>
            </template>
            </tbody>
          </template>
        </vs-table>
      </vs-tab>
      <vs-tab label="Платежи">
        <vs-table
          ref="table"
          :data="accountPaymentsInfo"
          class="financial-analytics-tariffs-table"
          no-data-text="Платежей нет"
        >
          <template slot="thead">
            <vs-th>Тип</vs-th>
            <vs-th>Месяц</vs-th>
            <vs-th>Дата прохождения платежа</vs-th>
            <vs-th>Сумма</vs-th>
            <vs-th>Комиссия</vs-th>
            <vs-th>Итого</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
            <template v-for="(tr, indextr) in data">
              <vs-tr :data="tr" :key="indextr" class="tariff-row financial-analytics-tariffs-table__row">
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.invoice_type }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  <span class="capitalize">
                    {{ tr.monthyear }}
                  </span>
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.payment_passage_date }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.amount | numberWithSpaces }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.amount_agency | numberWithSpaces }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.all_amount | numberWithSpaces }}
                </vs-td>
              </vs-tr>
            </template>
            </tbody>
          </template>
        </vs-table>
      </vs-tab>
      <vs-tab v-if="showRefunds" label="Возвраты">
        <vs-table
          ref="table"
          :data="accountRefundsInfo"
          class="financial-analytics-tariffs-table"
          no-data-text="Возвратов нет"
        >
          <template slot="thead">
            <vs-th>Сумма</vs-th>
            <vs-th>Дата добавления</vs-th>
            <vs-th>Дата создания</vs-th>
            <vs-th>Чек</vs-th>
            <vs-th>Создатель</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
            <template v-for="(tr, indextr) in data">
              <vs-tr :data="tr" :key="indextr" class="tariff-row financial-analytics-tariffs-table__row">
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.all_amount | numberWithSpaces }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  <span class="capitalize">
                    {{ tr.created_at | moment }}
                  </span>
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.payment_create_date | moment }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.check_number || '-' }}
                </vs-td>
                <vs-td class="financial-analytics-tariffs-table__cell">
                  {{ tr.author ? tr.author.name : '-' }}
                </vs-td>
              </vs-tr>
            </template>
            </tbody>
          </template>
        </vs-table>
      </vs-tab>
      <vs-tab label="Пени">
        <vs-table
          :data="accountFineInfo" max-items="20" pagination noDataText="Пени нет"
          class="w-full account-finance-info-table financial-analytics-tariffs-table"
        >
          <template slot="thead">
            <vs-th>Месяц начисления пени</vs-th>
            <vs-th>Неоплаченный период</vs-th>
            <vs-th>Задолженность</vs-th>
            <vs-th>Начало расчета</vs-th>
            <vs-th>Конец расчета</vs-th>
            <vs-th>Ставка ЦБ</vs-th>
            <vs-th>Кол-во дней 1/300</vs-th>
            <vs-th>Ставка % 1/300</vs-th>
            <vs-th>Кол-во дней 1/130</vs-th>
            <vs-th>Ставка % 1/130</vs-th>
            <vs-th>Формула</vs-th>
            <vs-th>Размер пени</vs-th>
          </template>

          <template slot-scope="{data}" ref="content">
            <vs-tr
              :key="indextr"
              v-for="(tr, indextr) in data"
              class="tariff-row financial-analytics-tariffs-table__row"
            >
              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="capitalize whitespace-no-wrap">{{
                    $parseDateFromString(tr.fine_month) | moment('MMMM YYYY')
                  }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="capitalize whitespace-no-wrap">{{
                    $parseDateFromString(tr.charge_month) | moment('MMMM YYYY')
                  }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.base_sum }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ $parseDateFromString(tr.calc_start_date) | moment('DD.MM.YYYY') }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ $parseDateFromString(tr.calc_end_date) | moment('DD.MM.YYYY') }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.key_rate }}%</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.days300 }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.value300 }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.days130 }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.value130 }}</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span v-if="tr.days300" class="whitespace-no-wrap">{{ tr.base_sum }} × {{ tr.days300 }} × 1/300 × {{ tr.key_rate }}%</span>
                <span v-if="tr.days130" class="whitespace-no-wrap">{{ tr.base_sum }} × {{ tr.days130 }} × 1/130 × {{ tr.key_rate }}%</span>
              </vs-td>

              <vs-td class="financial-analytics-tariffs-table__cell">
                <span class="whitespace-no-wrap">{{ tr.sum }}</span>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-tab>
    </vs-tabs>

    <charge-privilege-popup ref="chargePrivilegePopup" :buildingsId="buildingsId" />

  </vx-card>
</template>

<script>

import ChargePrivilegePopup from "@/components/calculated-program/privileges/ChargePrivilegePopup";

export default {
  name:       "FinancialAnalyticsAccountMonthCard",
  components: {
    ChargePrivilegePopup,
  },
  props:      {
    buildingsId:  {},
    inMonthRange: {},
    showSummary:  {
      type:    Boolean,
      default: true,
    },
    summaryData:  {},
    title:        {
      default: 'Финансовая аналитика',
    },
    mainData:     {
      default() {
        return {
          accountFineInfo:     [],
          accountChargesInfo:  [],
          accountPaymentsInfo: [],
          accountRefundsInfo:  [],
        };
      },
    },
    showRefunds:  { type: Boolean },
  },
  computed:   {
    showInMonthRange: {
      get() {
        return this.inMonthRange;
      },
      set( v ) {
        this.$emit('update:inMonthRange', v);
      },
    },
    accountFineInfo() {
      return this.mainData.accountFineInfo || [];
    },
    accountChargesInfo() {
      return this.mainData.accountChargesInfo || [];
    },
    accountPaymentsInfo() {
      return this.mainData.accountPaymentsInfo || [];
    },
    accountRefundsInfo() {
      return this.mainData.accountRefundsInfo || [];
    },
  },
  methods:    {
    openChargePrivilegePopup( id ) {
      this.$refs.chargePrivilegePopup.open(id);
    },
  },
};
</script>

<style lang="scss">
.financial-analytics-account-month-summary-table {
  width: 100%;
  margin-bottom: 15px;
  border-collapse: collapse;

  th, td {
    padding: 5px;
  }

  th, td {
    width: 25%;
    text-align: center;
    border-left: 1px solid rgba(0, 0, 0, .1);
    border-right: 1px solid rgba(0, 0, 0, .1);
  }

  th {
    border-top: 1px solid rgba(0, 0, 0, .1);
  }

  td {
    border-bottom: 1px solid rgba(0, 0, 0, .1);
  }
}

.financial-analytics-tariffs-table {
  line-height: 1.2;


  thead {
    th {
      border: 1px solid rgba(0, 0, 0, .2);
      padding-top: 1rem !important;
      padding-bottom: 1rem !important;
    }
  }

  &__cell {
    padding: 5px 10px !important;
  }

  .vs-con-tbody {
    border: none;
  }

  &__group-row {
    background: #f2f2f2 !important;
    border-top: 1px solid rgba(0, 0, 0, .2);
    border-bottom: 1px solid rgba(0, 0, 0, .2);

    td {

      &:first-child {
        border-left: 1px solid rgba(0, 0, 0, .2);
      }

      &:last-child {
        border-right: 1px solid rgba(0, 0, 0, .2);
      }
    }

    .tariff-row__name {
      font-weight: 500;
      padding: 5px;

      &:not(.tariff-row__name--hidden) {
      }
    }
  }

  &__row {
    td {
      border: 1px solid rgba(0, 0, 0, .2) !important;
    }
  }

  tr {
    &:hover {
      transform: none !important;
    }
  }
}


.tariff-row {
  td {
    &:first-child {
      border-left: 1px solid rgba(0, 0, 0, .2);
    }

    &:last-child {
      border-right: 1px solid rgba(0, 0, 0, .2);
    }
  }


  &__name {
    padding: 0 10px 0;
    white-space: nowrap;

    &--hidden {
      opacity: 0;
    }

    &--center {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }

    &--full {
      display: block;
      font-size: .85rem;
    }
  }

  &__formula {
    display: flex;
    align-items: center;
    justify-content: center;
    word-break: break-all;
    white-space: nowrap;
    min-width: 400px;
    width: 30vw;
    position: relative;

    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 10px;
      background: #fff;
    }

    .tariff-formula {
      overflow: hidden;
      padding: 0 10px;
    }
  }

  &__unit-id {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    .con-select {
      max-width: 80px;

      .vs-select--input {
        padding: 5px 10px;
      }
    }
  }

  &__value {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__show-empty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__count-fine {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__extra-values {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  &__buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
  }
}
</style>
